import React from 'react';

import './spinner.scss';

const Spinner = (props) => (
	<div className='Loader'></div>
)

export default Spinner